// extracted by mini-css-extract-plugin
export default {"wrapper":"contact_wrapper__75Bb-","content":"contact_content__dAEB8","email":"contact_email__9n5i3"};